import { Grid, Image, Link } from '@tq/ui-components';
import React from 'react';
import authorityLinkData from './authorityLinkData';

export const NIFooterAuthorities: React.FC = () => {
  return (
    <Grid
      gridTemplateColumns={{
        base: 'repeat(2, 1fr)',
        md: 'repeat(3, 1fr)',
        lg: 'repeat(6, 1fr)',
      }}
      gridColumnGap={{ base: '1rem', lg: '2.75rem' }}
      gridRowGap={{ base: '1.125rem', md: '1.5rem', lg: '2.875rem' }}
      alignItems='center'
      justifyItems='center'
    >
      {authorityLinkData.map((item, index) => (
        <Link
          key={index}
          href={item.href}
          target='_blank'
          border='1px solid'
          borderColor='transparent'
          display='inline-block'
          p='.5rem'
          _hover={{ bg: 'neutral.2' }}
          _active={{ bg: 'neutral.5' }}
          _focus={{
            border: '1px solid',
            borderColor: 'blue.300',
            borderRadius: '4px',
            boxShadow: '0 0 3px 2px #2182EB',
          }}
        >
          <Image
            src={item.logo}
            w={{ ...item.width }}
            h={{ ...item.height }}
            objectFit='contain'
            alt={item.altText}
          />
        </Link>
      ))}
    </Grid>
  );
};
